module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Due to the sensitive nature of the material, certain sites in New Orleans have had their names changed or been reinvented as composites. This has been done in the interests of national security, to avoid providing a blueprint for those who would destroy us.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  })]), _c('a', {
    attrs: {
      "id": "page08"
    }
  })]), _c('a', {
    attrs: {
      "id": "page08"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210715c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061734106_frontmatterpage_02.vue
// module id = 69
// module chunks = 0